import React from "react";
import {
  withStyles,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";

const styles = (theme) => ({
  radioLabelText: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  radioIcon: {
    paddingTop: 8,
    paddingBottom: 8,
    color: theme.iconColor
  },
  disabled: {
    opacity: 0.5,
  },
});

const CustomRadioGroup = ({
  classes,
  options,
  helperText,
  error,
  onChange,
  value,
  disabled,
}) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <FormControl component="fieldset" error={error}>
      <RadioGroup
        column
        aria-label="position"
        value={value}
        onChange={handleChange}
      >
        {options.map((option) => (
          <FormControlLabel
            key={`dynamicRadioGrp_${option.value}`}
            classes={{
              label: classes.radioLabelText,
              disabled: classes.disabled,
            }}
            value={option.value}
            control={
              <Radio
                color="primary"
                size="small"
                classes={{ root: classes.radioIcon }}
              />
            }
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default withStyles(styles)(CustomRadioGroup);
